// Small shared helpers with no UI and no API.

/** "2D 06H" / "6H 12M" / "CLOSING" — a terse countdown to a deadline. Returns
 *  null when there is no deadline (e.g. a scheduled round with no dates yet). */
export function countdown(deadline: string | null, now: number = Date.now()): string | null {
  if (!deadline) return null;
  const ms = new Date(deadline).getTime() - now;
  if (Number.isNaN(ms)) return null;
  if (ms <= 0) return 'CLOSING';
  const mins = Math.floor(ms / 60000);
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  if (d > 0) return `${d}D ${String(h).padStart(2, '0')}H`;
  if (h > 0) return `${h}H ${String(m).padStart(2, '0')}M`;
  return `${m}M`;
}

/** A short clock like "13:02" from an ISO timestamp, in the viewer's locale. */
export function clock(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** A day label like "FRIDAY" for chat separators. */
export function dayLabel(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { weekday: 'long' }).toUpperCase();
}

export const ordinal = (n: number): string => {
  const s = ['TH', 'ST', 'ND', 'RD'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

const two = (n: number) => String(n).padStart(2, '0');
export const seq = (n: number): string => two(n);
